import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addLessonFavorite, addTrackFavorite, fetchFavoritesDebounced, removeLessonFavorite, removeTrackFavorite // @ts-expect-error Could not find a declaration file for module
} from '../../../../actions/FavoriteActions';
import { useLesson } from '../../../../features/lessons';
import { useTrack } from '../../../../features/tracks';
import { getIsFavoriteRequesting, getIsFavoriteSet // @ts-expect-error Could not find a declaration file for module
} from '../../../../selectors/favoriteSelectors';
export const useSaveFavoriteTrack = ({
  trackId,
  showTooltip
}) => {
  const {
    track,
    trackLoading
  } = useTrack(trackId);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchFavoritesDebounced());
  }, [dispatch]); // TODO: move to DFC

  const isRequesting = useSelector(state => getIsFavoriteRequesting(state, {
    trackId
  })) || trackLoading;
  const isSaved = useSelector(state => getIsFavoriteSet(state, {
    trackId
  }));
  const trackLanguage = track && track.language;
  const toggleSavedItem = useCallback(() => {
    if (isRequesting) {
      return;
    }

    dispatch(isSaved ? removeTrackFavorite(trackId.toString(), showTooltip) : addTrackFavorite(trackLanguage, trackId.toString(), showTooltip));
  }, [isRequesting, dispatch, isSaved, trackId, showTooltip, trackLanguage]);
  return [Boolean(isSaved), toggleSavedItem, isRequesting];
};
export const useSaveFavoriteLesson = ({
  lessonId,
  showTooltip
}) => {
  const {
    lesson,
    lessonLoading
  } = useLesson(lessonId);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchFavoritesDebounced());
  }, [dispatch]);
  const isRequesting = useSelector(state => getIsFavoriteRequesting(state, {
    lessonId
  })) || lessonLoading;
  const isSaved = useSelector(state => getIsFavoriteSet(state, {
    lessonId
  }));
  const lessonLanguage = lesson && lesson.language;
  const toggleSavedItem = useCallback(() => {
    if (isRequesting) {
      return;
    }

    dispatch(isSaved ? removeLessonFavorite(lessonId.toString(), showTooltip) : addLessonFavorite(lessonLanguage, lessonId.toString(), showTooltip));
  }, [isRequesting, lessonId, dispatch, isSaved, showTooltip, lessonLanguage]);
  return [isSaved, toggleSavedItem, isRequesting];
};